module.exports = __webpack_public_path__ + "cab45a818b635c40933b2969a3bbf900.jpg";